import { useReactFlow } from '@xyflow/react';
import { useKeyboardShortcut } from '@/features/canvas/engine/hooks/use-keyboard-shortcut';

export function useDeleteShortcut(
  onDelete: (ids: string[]) => void,
  onDeleteEdges?: (ids: string[]) => void,
) {
  const { getNodes, getEdges } = useReactFlow();
  useKeyboardShortcut(
    { keys: ['Delete', 'Backspace'] },
    (e) => {
      const selectedNodes = getNodes().filter((n) => n.selected).map((n) => n.id);
      // Locked edges have deletable: false from useEdgesFromYjs — skip them.
      const selectedEdges = getEdges()
        .filter((edge) => edge.selected && edge.deletable !== false)
        .map((edge) => edge.id);
      if (selectedNodes.length === 0 && selectedEdges.length === 0) return;
      e.preventDefault();
      if (selectedNodes.length > 0) onDelete(selectedNodes);
      if (selectedEdges.length > 0) onDeleteEdges?.(selectedEdges);
    },
  );
}
